/**
 * @desc 导入默认店铺信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/defaultShopInfo/importExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
